import type { ListName } from '@/models/types';

export const SP_LIST_NAMES: Record<ListName, string> = {
  OC_Employees: 'OC_Employees',
  OC_Projects: 'OC_Projects',
  OC_Allocations: 'OC_Allocations',
  OC_Applications: 'OC_Applications',
  OC_AppAssignments: 'OC_AppAssignments',
  OC_LicenseSync: 'OC_LicenseSync',
  OC_Expenses: 'OC_Expenses',
  OC_ExpenseReports: 'OC_ExpenseReports',
  OC_DailySnapshot: 'OC_DailySnapshot',
  OC_ChangeLog: 'OC_ChangeLog',
  OC_CloudSpend: 'OC_CloudSpend',
  OC_AppAdmins: 'OC_AppAdmins',
  OC_GroupsAndMailboxes: 'OC_GroupsAndMailboxes',
  OC_AppAccessList: 'OC_AppAccessList',
  OC_Devices: 'OC_Devices',
  OC_CostAllocations: 'OC_CostAllocations',
};

export const GRAPH_SCOPES = {
  userRead: ['User.Read'],
  usersReadAll: ['User.Read.All'],
  directoryRead: ['Directory.Read.All'],
  organizationRead: ['Organization.Read.All'],
  sitesReadWrite: ['Sites.ReadWrite.All'],
  mailSend: ['Mail.Send'],
  filesReadWrite: ['Files.ReadWrite.All'],
};

export const APP_CATEGORIES = [
  'DevTools',
  'Productivity',
  'AI',
  'Cloud',
  'Design',
  'Other',
] as const;

export const EXPENSE_CATEGORIES = [
  'Travel',
  'Equipment',
  'Software',
  'Office',
  'Training',
  'Other',
] as const;

export const PROJECT_STATUSES = ['Active', 'On Hold', 'Completed'] as const;

export const DEFAULT_CURRENCY = 'GBP';

export const BILL_PHOTO_MAX_WIDTH = 1920;
export const BILL_PHOTO_QUALITY = 0.7;
export const BILL_PHOTO_MAX_SIZE_MB = 4;

// Microsoft SKU friendly names mapping
export const SKU_FRIENDLY_NAMES: Record<string, string> = {
  O365_BUSINESS_ESSENTIALS: 'Microsoft 365 Business Basic',
  O365_BUSINESS_PREMIUM: 'Microsoft 365 Business Standard',
  SPB: 'Microsoft 365 Business Premium',
  ENTERPRISEPACK: 'Office 365 E3',
  ENTERPRISEPREMIUM: 'Office 365 E5',
  DEVELOPERPACK_E5: 'Microsoft 365 E5 Developer',
  VISIOCLIENT: 'Visio Plan 2',
  PROJECTPREMIUM: 'Project Plan 5',
  POWER_BI_PRO: 'Power BI Pro',
  FLOW_FREE: 'Power Automate Free',
  POWERAPPS_VIRAL: 'Power Apps Plan 2 Trial',
  WINDOWS_STORE: 'Windows Store for Business',
  EXCHANGESTANDARD: 'Exchange Online Plan 1',
  DYN365_ENTERPRISE_PLAN1: 'Dynamics 365 Plan',
  AX7_USER_TRIAL: 'Dynamics 365 Trial',
  MS_TEAMS_IW: 'Microsoft Teams Trial',
  AAD_PREMIUM: 'Azure AD Premium P1',
  AAD_PREMIUM_P2: 'Azure AD Premium P2',
  INTUNE_A: 'Microsoft Intune Plan 1',
  EMS: 'Enterprise Mobility + Security E3',
  EMSPREMIUM: 'Enterprise Mobility + Security E5',
  WIN_DEF_ATP: 'Microsoft Defender for Endpoint P2',
  IDENTITY_THREAT_PROTECTION: 'Microsoft 365 E5 Security',
};
